import { createReduxActionTypes } from '../../../utils/actionFactory';

const SET_ACCOUNTS = 'SET_ACCOUNTS';
const RESET = 'RESET';
const SET_SELECTED_ACCOUNT = 'SET_SELECTED_ACCOUNT';
const SET_SUBSCRIPTIONS = 'SET_SUBSCRIPTIONS';
const UPDATE_FILTERS = 'UPDATE_FILTERS';
const SET_REFRESH = 'SET_REFRESH';

export const actionTypes = createReduxActionTypes('SUBSCRIPTIONS_IMPROVED', [
  SET_ACCOUNTS,
  SET_SELECTED_ACCOUNT,
  SET_SUBSCRIPTIONS,
  UPDATE_FILTERS,
  SET_REFRESH,
  RESET
]);

const DEFAULT_STATE = {
  accounts: [],
  selectedAccount: {},
  selectOptions: [],
  subscriptions: [],
  filters: {
    search: '',
    status: [{ value: 'ACTIVE', label: 'Active' }],
    product: [],
    account: [],
    groupedBy: [{ label: 'Product category', value: 'commercialProduct' }],
    billingStatus: []
  },
  productOptions: [],
  groupByOptions: [
    { label: 'User', value: 'user' },
    { label: 'Account', value: 'accountName' },
    { label: 'Product category', value: 'commercialProduct' },
    { label: 'Status', value: 'status' },
    { label: 'Product', value: 'sku' },
    { label: 'Ident', value: 'ident' }
  ],
  refresh: false
};

export const reducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case actionTypes[SET_ACCOUNTS]: {
      const { accounts, selectOptions, selectedAccount } = action;
      return { ...state, accounts, selectOptions, selectedAccount };
    }
    case actionTypes[SET_SELECTED_ACCOUNT]: {
      const { selectedAccount } = action;
      return {
        ...state,
        selectedAccount
      };
    }
    case actionTypes[SET_SUBSCRIPTIONS]: {
      const { subscriptions, productOptions } = action;
      return {
        ...state,
        subscriptions,
        productOptions
      };
    }
    case actionTypes[SET_REFRESH]: {
      const { refresh } = action;
      return {
        ...state,
        refresh
      };
    }
    case actionTypes[UPDATE_FILTERS]: {
      const { value, key } = action;
      return {
        ...state,
        filters: {
          ...state.filters,
          [key]: value
        }
      };
    }
    case actionTypes[RESET]: {
      return DEFAULT_STATE;
    }
    default:
      return state;
  }
};

export const actions = {
  setAccounts: (accounts, selectOptions, selectedAccount) => ({
    type: actionTypes[SET_ACCOUNTS],
    accounts,
    selectOptions,
    selectedAccount
  }),
  setSelectedAccount: selectedAccount => ({
    type: actionTypes[SET_SELECTED_ACCOUNT],
    selectedAccount
  }),
  setSubscriptions: (subscriptions, productOptions) => ({
    type: actionTypes[SET_SUBSCRIPTIONS],
    subscriptions,
    productOptions
  }),
  setRefresh: refresh => ({
    type: actionTypes[SET_REFRESH],
    refresh
  }),
  updateFilters: ({ value, key }) => ({
    type: actionTypes[UPDATE_FILTERS],
    value,
    key
  }),
  resetSubscriptions: () => ({
    type: actionTypes[RESET]
  })
};
